module.exports = __WEBPACK_EXTERNAL_MODULE_loaders_glTF_index__;